module.exports = __webpack_public_path__ + "img/social_media_dayu.1eba27ab.png";